const userRoles = {
    SuperAdmin: '1',
    ClientAdmin: '2',
    Maker: '3',
    Checker: '4'
}

export default userRoles
